<template>
  <div
    v-if="getPayments"
    class="receivables-payments">
    <el-row v-if="getPayments.length == 1">
      <el-col>
        <el-button
          type="success"
          style="float:right;margin-bottom: 15px;"
          round
          @click="addReceivableTransactionVisibility = true">Add new Receivable Transaction</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-table
        ref="receivables-payment-table"
        :data="getPayments"
        style="width: 100%">
        <el-table-column type="expand">
          <template slot-scope="scope">
            <el-row
              v-if="scope.row.receipts.length > 0"
              :gutter="10">
              <el-col
                v-for="(receipt, index) in scope.row.receipts"
                :span="7"
                :key="receipt.id">
                <el-card>
                  <div
                    slot="header"
                    class="clearfix">
                    <el-row :gutter="10">
                      <el-col :span="16">
                        <h4><strong>RECEIPT #{{ index + 1 }}</strong></h4>
                      </el-col>
                      <el-col :span="4">
                        <el-button
                          v-if="receipt.receiptFile"
                          icon="el-icon-download"
                          circle
                          @click="handleDownloadReceipt(receipt.receiptFile)"></el-button>
                      </el-col>
                      <el-col :span="4">
                        <el-button
                          icon="el-icon-delete"
                          circle
                          @click="handleDeleteReceipt(scope.row.id, receipt.id)"></el-button>
                      </el-col>
                    </el-row>
                  </div>
                  <el-row>
                    <p>
                      <strong>AMOUNT:</strong>
                      <span style="float:right;">{{ receipt.amount | currency }}</span>
                    </p>
                  </el-row>
                  <el-row>
                    <p>
                      <strong>STATUS:</strong>
                      <span style="float:right;">
                        <el-tag
                          v-if="receipt.status === 'pending-confirmation'"
                          type="warning">
                          {{ receipt.status }}
                        </el-tag>
                        <el-tag
                          v-if="receipt.status === 'confirmed'"
                          type="success">
                          {{ receipt.status }}
                        </el-tag>
                      </span>
                    </p>
                  </el-row>
                  <el-row>
                    <p>
                      <strong>PAID AT:</strong>
                      <span style="float:right;">{{ receipt.datePaidAt | moment('DD/MM/YYYY') }}</span>
                    </p>
                  </el-row>
                  <el-row v-if="receipt.observation !== ''">
                    <p><strong>OBS:</strong></p>
                    <span class="receipt-observation">{{ receipt.observation }}</span>
                  </el-row>
                  <el-row v-if="receipt.confirmedBy">
                    <p>
                      <strong>CONFIRMED BY:</strong>
                      <span style="float:right;">
                        {{ receipt.confirmedBy.firstName }} {{ receipt.confirmedBy.lastName }}
                      </span>
                    </p>
                  </el-row>
                  <br>
                  <el-row>
                    <el-col :span="24">
                      <el-button
                        v-if="receipt.status === 'pending-confirmation'"
                        type="success"
                        size="small"
                        icon="el-icon-check"
                        class="btn-block"
                        @click="confirmReceipt(scope.row.id, receipt.id)">Confirm receipt</el-button>
                      <el-button
                        v-if="receipt.status === 'confirmed'"
                        size="small"
                        icon="el-icon-refresh"
                        class="btn-block"
                        @click="undoConfirmReceipt(scope.row.id, receipt.id)">Undo confirmation</el-button>
                    </el-col>
                  </el-row>
                </el-card>
              </el-col>
            </el-row>
            <el-row v-else>
              <p>No receipt added yet.</p>
            </el-row>
          </template>
        </el-table-column>
        <el-table-column
          type="index"
          width="50">
        </el-table-column>
        <el-table-column
          label="Amount">
          <template slot-scope="scope">
            {{ scope.row.amount | currency }}
            <el-button
              v-if="scope.row.status !== 'paid'"
              type="text"
              size="small"
              class="edit-btn--amount"
              @click="setNewValue(scope.row.id, scope.$index, 'amount')">
              Edit
            </el-button>
          </template>
        </el-table-column>
        <el-table-column
          label="Due">
          <template slot-scope="scope">
            {{ scope.row.due | moment('DD/MM/YYYY') }}
            <el-button
              class="edit-btn--paid"
              type="text"
              size="small"
              @click="setNewValue(scope.row.id, scope.$index, 'due')">
              Edit
            </el-button>
          </template>
        </el-table-column>
        <el-table-column
          label="Amount paid">
          <template slot-scope="scope">
            {{ scope.row.amountPaid | currency }}
          </template>
        </el-table-column>
        <el-table-column
          label="Amount pending">
          <template slot-scope="scope">
            {{ getAmountPending(scope.row.receipts) | currency }}
          </template>
        </el-table-column>
        <el-table-column
          label="Status">
          <template slot-scope="scope">
            <el-tag
              v-if="scope.row.status === 'confirmed'"
              style="text-transform:uppercase;"
              type="success">
              Confirmed
            </el-tag>
            <el-tag
              v-if="scope.row.status === 'pending-confirmation'"
              class="pending-confirmation"
              style="text-transform:uppercase;">
              Pending Confirmation
            </el-tag>
            <el-tag
              v-if="scope.row.status === 'pending'"
              style="text-transform:uppercase;"
              type="warning">
              Pending
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="Payments">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.receipts.length > 0"
              icon="el-icon-view"
              circle
              @click="handleViewPaymentsClick(scope.$index, scope.row)">
              {{ scope.row.receipts.length }}
            </el-button>
            <el-button
              icon="el-icon-plus"
              circle
              @click="handleAddPaymentDialog(scope.row.id, 'payForm')">
            </el-button>
          </template>
        </el-table-column>
        <el-table-column
          v-if="getPayments.length > 1"
          label="Delete payment">
          <template slot-scope="scope">
            <el-button
              icon="el-icon-delete"
              circle
              @click="handleDeleteRt(scope.row.id)">
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <br/>
      <el-row>
        <el-col :span="8">
          <p>
            <strong>
              TOTAL LEFT:
            </strong>
          </p>
        </el-col>
        <el-col :span="8">
          <p>
            <strong>
              {{ getTotalLeft | currency }}
            </strong>
          </p>
        </el-col>
        <el-col :span="8">
          <el-tag
            v-if="getPaymentStatus === 'pending' || getPaymentStatus === 'partially-pending'"
            type="warning"
            style="text-transform:uppercase;">
            {{ getPaymentStatus === 'pending' ? 'Pending' : 'partially pending' }}
          </el-tag>
          <el-tag
            v-if="getPaymentStatus === 'paid'"
            type="success"
            style="text-transform:uppercase;">
            Paid
          </el-tag>
        </el-col>
      </el-row>
      <el-dialog
        :title="dialogTitle"
        :visible.sync="dialogVisible"
        class="edit-value">
        Current:
        <span
          v-if="editing==='amount'"
          class="current-amount">
          {{ oldValue | currency }}
        </span>
        <span
          v-if="editing!=='amount' && oldValue"
          class="current-date">
          {{ oldValue | moment('DD/MM/YYYY') }}
        </span>
        <br>
        <span
          v-if="editing==='amount'"
          class="dolar-icon">
          $
        </span>
        <masked-input
          v-if="editing==='amount'"
          :mask="getMask"
          :guide="false"
          v-model="newValue"
          type="text"
          name="amount"
          class="amount-input"
          maxlength="11"
          placeholder-char="#"
          placeholder="Insert a new amount value">
        </masked-input>
        <el-date-picker
          v-if="editing!=='amount'"
          v-model="newValue"
          class="date-input"
          format="dd/MM/yyyy"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder="Pick a day">
        </el-date-picker>
        <span
          slot="footer"
          class="dialog-footer">
          <el-button
            @click="dialogVisible = false">
            Cancel
          </el-button>
          <el-button
            :disabled="!newValue"
            class="update-btn"
            type="primary"
            @click="updateValue">
            Confirm
          </el-button>
        </span>
      </el-dialog>

      <el-dialog
        :visible.sync="addPaymentVisibility"
        title="Add new payment receipt"
        width="45%"
        @close="resetForm('payForm')">
        <el-form
          ref="payForm"
          :model="payForm"
          :rules="payFormRules"
          label-position="top"
          label-width="120px">
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item
                label="Amount Paid"
                prop="amountPaid">
                <div class="input-group masked-input-radius">
                  <span class="input-group-addon">$</span>
                  <masked-input
                    v-model="payForm.amountPaid"
                    :mask="getMask"
                    :guide="false"
                    type="text"
                    name="phone"
                    class="el-input__inner"
                    placeholder-char="#"
                    placeholder="Insert the amount paid in the receipt">
                  </masked-input>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="Paid at"
                prop="paidAt">
                <el-date-picker
                  v-model="payForm.paidAt"
                  type="date"
                  placeholder="Pick a date"
                  style="width: 100%;"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item
                label="Attach the receipt:"
                prop="fileList">
                <div class="el-upload el-upload--text">
                  <el-button
                    :plain="true"
                    class="add-receipt-button"
                    icon="document"
                    type="default"
                    @click.native="fireClickFile('paymentFileInput')">
                    Choose file
                  </el-button>
                  <br>
                  <span v-if="getFileName">
                    <strong>File selected:</strong> {{ getFileName }}
                    <el-button
                      size="small"
                      icon="el-icon-close"
                      @click="removeFile('paymentFileInput')"></el-button>
                  </span>
                  <input
                    ref="paymentFileInput"
                    type="file"
                    name="file"
                    class="el-upload__input"
                    @change="getFile">
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item
            label="Observation"
            prop="desc">
            <el-input
              v-model="payForm.paymentReceiptObservation"
              type="textarea"></el-input>
          </el-form-item>
        </el-form>
        <span
          slot="footer"
          class="dialog-footer">
          <el-button @click="addPaymentVisibility = false">Cancel</el-button>
          <el-button
            type="primary"
            @click="submitPayment('payForm')">Add receipt</el-button>
        </span>
      </el-dialog>

      <el-dialog
        :visible.sync="addReceivableTransactionVisibility"
        title="Add new Receivable Transaction"
        width="45%"
        @close="resetForm('newRTForm')">
        <el-form
          ref="newRTForm"
          :model="newRTForm"
          :rules="newRTFormRules"
          label-position="top"
          label-width="120px">
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item
                label="Payment:"
                class="payment-item"
                required>
                <el-col :span="12">
                  <el-form-item prop="rtAmount1">
                    <masked-input
                      v-model="newRTForm.rtAmount1"
                      :mask="getMask"
                      :guide="false"
                      type="text"
                      name="amount"
                      class="amount-input"
                      placeholder-char="#"
                      placeholder="Insert a amount value">
                    </masked-input>
                  </el-form-item>
                </el-col>
                <el-col
                  :span="12">
                  <el-form-item prop="rtDue1">
                    <el-date-picker
                      v-model="newRTForm.rtDue1"
                      class="date-input"
                      format="dd/MM/yyyy"
                      value-format="yyyy-MM-dd"
                      type="date"
                      placeholder="Due Date">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-form-item
              class="buttons"
              style="float: right;">
              <el-button
                type="success"
                @click="submitNewRT('newRTForm')">Create Receivable Transaction</el-button>
            </el-form-item>
          </el-row>
        </el-form>
      </el-dialog>
    </el-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment';
import apiUrl from '@/services/api_url';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import getFileUploadHeaders from '@/services/http-file-headers';
import client from '@/services/http';

export default {
  data() {
    return {
      editing: '',
      oldValue: '',
      newValue: '',
      editingPaymentId: 0,
      dialogVisible: false,
      dialogTitle: '',
      paymentModalVisible: false,
      currentTransactionId: null,
      fileList: [],
      addPaymentVisibility: false,
      addReceivableTransactionVisibility: false,
      activeRtForm: 0,
      newRTForm: {
        rtAmount1: '',
        rtDue1: null,
      },
      newRTFormRules: {
        rtAmount1: { required: true, message: 'Please insert an amount', trigger: 'blur' },
        rtDue1: [
          { required: true, message: 'Please pick a due date', trigger: 'change' },
        ],
      },
      payForm: {
        paymentReceiptObservation: '',
        amountPaid: '',
        fileList: [],
        paidAt: '',
      },
      payFormRules: {
        amountPaid: [
          { required: true, message: 'Amount paid is required' },
        ],
        paidAt: [
          { required: true, message: 'The date is required' },
        ],
      },
    };
  },
  computed: {
    ...mapGetters({
      getRTItem: 'getRTItem',
    }),
    getMask() {
      return createNumberMask({
        prefix: '',
        allowDecimal: true,
      });
    },
    getPaymentStatus() {
      if (this.getRTItem.data) {
        return this.getRTItem.data.status;
      }
      return false;
    },
    getPaymentTotal() {
      if (this.getRTItem.data) {
        return this.getRTItem.data.amount;
      }
      return false;
    },
    getPaymentObs() {
      if (this.getRTItem.data) {
        return this.getRTItem.data.observation;
      }
      return false;
    },
    getPayments() {
      if (this.getRTItem.data) {
        return this.getRTItem.data.receivableTransactions;
      }
      return [];
    },
    getTotalLeft() {
      let paymentsDone = 0;
      let paymentsTotal = 0;
      for (let i = 0; i < this.getPayments.length; i += 1) {
        paymentsTotal += parseFloat(this.getPayments[i].amount);
        paymentsDone += parseFloat(this.getPayments[i].amountPaid);
      }
      return paymentsTotal - paymentsDone;
    },
    getUploadUrl() {
      return `${apiUrl}receivabletransactions/${
        this.currentTransactionId
      }/sendReceipt/`;
    },
    getHeaders() {
      return getFileUploadHeaders();
    },
    getFileName() {
      return this.payForm.fileList.name;
    },
  },
  methods: {
    ...mapActions({
      payRT: 'payRT',
      confirmRTPayment: 'confirmRTPayment',
      undoRTPayment: 'undoRTPayment',
      updateRTPaymentAmount: 'updateRTPaymentAmount',
      updateRTPaymentDue: 'updateRTPaymentDue',
      updateRTPaymentPaidDate: 'updateRTPaymentPaidDate',
      reloadRTItem: 'reloadRTItem',
      undoRTPaymentConfirmation: 'undoRTPaymentConfirmation',
      deleteRTReceipt: 'deleteRTReceipt',
      deleteRT: 'deleteRT',
      confirmRTReceipt: 'confirmRTReceipt',
      undoConfirmRTReceipt: 'undoConfirmRTReceipt',
      getSearchedReceivableTransactionsData:
        'getSearchedReceivableTransactionsData',
    }),
    fireClickFile(ref) {
      this.$refs[ref].click();
    },
    handleViewPaymentsClick(index, row) {
      this.$refs['receivables-payment-table'].toggleRowExpansion(row, true);
    },
    uploadEmptyReceipt() {
      client.post(this.getUploadUrl, {}, this.getHeaders)
        .then(() => {
          this.paymentModalVisible = false;
          this.reloadRTItem();
          this.getSearchedReceivableTransactionsData();
          this.fileList = [];
        });
    },
    openPayTransactionModal(paymentId) {
      this.paymentModalVisible = true;
      this.currentTransactionId = paymentId;
    },
    confirmTransactionPayment(paymentId) {
      this.$confirm('Are you sure you want to confirm payment?', 'Warning', {
        confirmButtonText: 'Yes, confirm',
        cancelButtonText: 'Cancel',
        type: 'warning',
      })
        .then(() => {
          this.confirmRTPayment({ paymentId });
        })
        .catch(() => false);
    },
    setNewValue(id, index, value) {
      this.editing = value;
      this.newValue = '';
      this.editingPaymentId = id;
      switch (value) {
        case 'amount':
          this.dialogTitle = `Edit amount for payment #${index + 1}`;
          this.oldValue = this.getPayments[index].amount;
          break;
        case 'due':
          this.dialogTitle = `Edit due for payment #${index + 1}`;
          this.oldValue = this.getPayments[index].due;
          break;
        case 'paid':
          this.dialogTitle = `Edit paid date for payment #${index + 1}`;
          this.oldValue = this.getPayments[index].paidOn;
          break;
        default:
          break;
      }
      this.dialogVisible = true;
    },
    updateValue() {
      let newAmount = this.newValue;
      switch (this.editing) {
        case 'amount':
          while (newAmount.indexOf(',') !== -1) {
            newAmount = newAmount.replace(',', '');
          }
          this.updateRTPaymentAmount({
            id: this.editingPaymentId,
            amount: newAmount,
          });
          break;
        case 'due':
          this.updateRTPaymentDue({
            id: this.editingPaymentId,
            due: this.newValue,
          });
          break;
        case 'paid':
          this.updateRTPaymentPaidDate({
            id: this.editingPaymentId,
            date: this.newValue,
          });
          break;
        default:
          break;
      }
      this.dialogVisible = false;
    },
    submitUpload() {
      this.$refs.uploadReceipt.submit();
    },
    uploadSuccess() {
      this.paymentModalVisible = false;
      this.reloadRTItem();
      this.getSearchedReceivableTransactionsData();
      this.fileList = [];
    },
    uploadError() {
      this.$message.error('Oops! Something went wrong.');
      this.paymentModalVisible = false;
    },
    undoPaymentConfirmation() {
      return false;
    },
    handleDeleteReceipt(rtId, receiptId) {
      this.$confirm('Are you sure you want to delete this receipt?', 'Warning', {
        confirmButtonText: 'Yes, delete',
        cancelButtonText: 'Cancel',
        type: 'warning',
      })
        .then(() => {
          this.deleteRTReceipt({ rtId, receiptId });
        })
        .catch(() => false);
    },
    undoConfirmReceipt(rtId, receiptId) {
      this.$confirm('Are you sure you want to undo the confirmation for this receipt?', 'Warning', {
        confirmButtonText: 'Yes, undo confirmation',
        cancelButtonText: 'Cancel',
        type: 'warning',
      })
        .then(() => {
          this.undoConfirmRTReceipt({ rtId, receiptId });
        })
        .catch(() => false);
    },
    confirmReceipt(rtId, receiptId) {
      this.$confirm('Are you sure you want to confirm this receipt?', 'Warning', {
        confirmButtonText: 'Yes, confirm',
        cancelButtonText: 'Cancel',
        type: 'warning',
      })
        .then(() => {
          this.confirmRTReceipt({ rtId, receiptId });
        })
        .catch(() => false);
    },
    handleDeleteRt(id) {
      this.$confirm('Are you sure you want to delete this transaction?', 'Warning', {
        confirmButtonText: 'Yes, confirm',
        cancelButtonText: 'Cancel',
        type: 'warning',
      })
        .then(() => {
          this.deleteRT(id);
        })
        .catch(() => false);
    },
    handleAddPaymentDialog(id) {
      this.addPaymentVisibility = true;
      this.activeRtForm = id;
    },
    submitNewRT(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$store.dispatch('addNewRT', {
            id: this.$route.params.id, data: { amount: parseFloat(this.newRTForm.rtAmount1.replace(/[^0-9.]+/g, '')), due: moment(this.newRTForm.rtDue1).format('YYYY-MM-DD') },
          });
          this.newRTForm.rtAmount1 = '';
          this.newRTForm.rtDue1 = '';
          this.addReceivableTransactionVisibility = false;
        }
        return false;
      });
    },
    submitPayment(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const formData = new FormData();
          formData.append('amount', parseFloat(this.payForm.amountPaid.replace(/[^0-9.]+/g, '')));
          formData.append('datePaidAt', moment(this.payForm.paidAt).format('YYYY-MM-DD'));
          formData.append('receipt', this.payForm.fileList);
          formData.append('observation', this.payForm.paymentReceiptObservation);
          formData.append('fullResponse', true);
          this.$store.dispatch('setRTReceipt', {
            rtId: this.activeRtForm, payment: formData, scope: this,
          });
          this.addPaymentVisibility = false;
          this.payForm.paymentReceiptObservation = '';
          this.payForm.fileList = [];
          this.payForm.amountPaid = '';
          this.payForm.paidAt = '';
        }
        return false;
      });
    },
    getFile(e) {
      this.payForm.fileList = e.target.files[0]; // eslint-disable-line
    },
    removeFile(ref) {
      this.$refs[ref].value = '';
      this.payForm.fileList = [];
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      // if (formName === 'payForm') {
      //   this.$refs.paymentFileInput.value = '';
      // }
    },
    handleDownloadReceipt(file) {
      const link = document.createElement('a');
      link.href = file;
      link.click();
    },
    getAmountPending(receipts) {
      const filterPending = receipts
        .filter(receipt => receipt.status === 'pending-confirmation')
        .map(receipt => parseInt(receipt.amount, 0))
        .reduce((a, b) => a + b, 0);
      return filterPending;
    },
  },
};
</script>

<style lang="scss">
.receivables-payments {
  .receipt-observation {
    display: block;
    background: #f7f7f7;
    border-radius: 5px;
    padding: 1em;
  }
  .el-card__body {
    flex-direction: column;
  }
  .amount-input {
      width: 100%;
      height: 40px;
      border: 1px solid #dcdfe6;
      border-radius: 4px;
      padding-left: 14px;
    }
  .is-receivable {
    .expanded tr{
      background-color: #f9f9f9;
    }
    .el-button--success.is-plain.new-receipt {
      color: #67c23a;
      background: #f0f9eb;
      border-color: #c2e7b0;
      &:hover {
        background: #67c23a;
        border-color: #67c23a;
        color: #fff;
      }
    }
    .el-button.is-plain span {
      text-decoration: none;
    }
  }
  .total-left {
    text-transform: uppercase;
    font-size: 1.2em;
    padding: 1em;
    float: right;
  }
  .el-upload,
  .el-upload.el-upload--text,
  .el-upload-dragger,
  .new-receipt {
    width: 100%;
  }
  .el-row {
    width: 100%;
  }
  .payments-header{
    .payment-obs-title,.payment-total {
      font-size:1.4em;
      text-transform: uppercase;
    }
    .payment-obs {
      font-size: 1.4em;
    }
    .payment-due-info {
      text-align: right;
    }
  }
  .el-upload {
    text-align: left;
  }
  input[name="file"].el-upload__input {
    display: none;
  }
  .payments-table{
      table{
        width: 100%;
        &-amount-input,&-due-input{
          width:70%;
        }
      }
      tr{
        border-bottom:1px solid rgb(236, 235, 235);
      }
      th{
        width: 15%;
        padding: 10px 5px;
      }
      th.edit-download-receipt{
        width: 15%;
      }
      th.transaction-status{
        width: 10%;
      }
      th.buttons{
        width: 20%;
      }
      td {
        padding: 15px 0 15px 5px;
      }
      .table-input{
        line-height: 32px;
        width:70%;
      }
      .pay-btn,.undo-payment-btn{
        height: 32px;
        width:90%;
        margin:0 auto;
        padding: 1px 8px 0 8px;
        font-weight: bold;
        vertical-align: bottom;
      }
      .el-tag.table-tags {
        width: 80%;
        text-align: center;
        &.pending {
          background: #f7ba2a;
          color: white;
        }
        &.paid {
          background: #13ce66;
          color: white;
        }
      }
      .general-status{
        display: block;
        padding: 10px;
        font-weight: bold;
        &.pending{
          color:#f7ba2a;
        }
      }
      .pending-confirmation{
        height:40px;
        line-height: 18px;
        text-align: center;
      }
    }
    tr {
      border-bottom: 1px solid rgb(236, 235, 235);
    }
    th {
      width: 15%;
      padding: 10px 5px;
    }
    th.edit-download-receipt {
      width: 15%;
    }
    th.transaction-status {
      width: 10%;
    }
    th.buttons {
      width: 20%;
    }
    td {
      padding: 15px 0 15px 5px;
    }
    .table-input {
      line-height: 32px;
      width: 70%;
    }
    .pay-btn,
    .undo-payment-btn {
      height: 32px;
      width: 90%;
      margin: 0 auto;
      padding: 1px 8px 0 8px;
      font-weight: bold;
      vertical-align: bottom;
    }
    .el-tag.table-tags {
      width: 80%;
      text-align: center;
      &.pending {
        background: #f7ba2a;
        color: white;
      }
      &.paid {
        background: #13ce66;
        color: white;
      }
    }
    .general-status {
      display: inline-block;
      padding: 1em;
      font-weight: bold;
      text-transform: uppercase;
      &.pending {
        color: #f7ba2a;
      }
    }
    .pending-confirmation {
      height: 40px;
      line-height: 18px;
      text-align: center;
    }
  .edit-value {
    .dolar-icon {
      padding: 6px 12px;
      font-size: 14px;
      font-weight: normal;
      line-height: 1;
      color: #555555;
      text-align: center;
      background-color: #eeeeee;
      border: 1px solid #ccc;
    }
    .amount-input {
      width: 90%;
      padding: 2px 12px;
      margin-left: -4px;
    }
  }
  .upload-receipt {
    width: 100%;
    .el-upload.el-upload--text {
      width: 100%;
      .el-upload-dragger {
        width: 100%;
      }
    }
    .el-upload__input {
      display: none !important;
    }
  }
  .dialog-footer {
    button {
      font-weight: bold;
    }
  }
  .receipt-icons {
    font-size: 1.5em;
    margin-left: 20px;
    cursor: pointer;
  }
  .el-tag {
    text-transform: uppercase;
  }
  .receipt {
    &__confirmation-button {
      float: right;
      clear: both;
      padding: 0;
      font-weight: bold;
      .el-button {
        padding: 0 10px;
      }
    }
    &__title {
      text-transform: uppercase;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/receivables/receivable/receivable-details/partials/ReceivablePayments.vue